export default {
  methods: {
    async render_two(data) {
      let xAxisData = data && data.signUpTotal && data.signUpTotal.length ? data.signUpTotal.map(v=>v.dateTime) : []
      let seriesData1 = data && data.signUpTotal && data.signUpTotal.length ? data.signUpTotal.map(v=>v.total) : []
      let seriesData2 = data && data.customerTotal && data.customerTotal.length ? data.customerTotal.map(v=>v.total) : []
      let option = {
        title: {},
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          // orient: "vertical",
          icon: "circle", //图例形状
          padding: 0,
          top: "top",
          right: 20,
          itemWidth: 10, //小圆点宽度
          itemHeight: 10, // 小圆点高度
          itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
          textStyle: {
            fontSize: 14,
            color: "#000",
          },
        },
        grid: {
          left: 10,
          // right: '4%',
          right: 10,
          bottom: 30,
          top: 30,
          containLabel: true
        },
        xAxis: {
          data: xAxisData,
        },
        yAxis: {
          name: ''
        },
        dataZoom: {
          type: 'inside',
          start: 0,
          end: ((window.innerWidth == 1920 ? 16 : 10)/seriesData1.length)*100
        },
        series: [
          {
            type: 'line',
            name: '报名人数',
            showSymbol: false,
            data: seriesData1,
          },
          {
            name: '总顾客数',
            type: 'line',
            showSymbol: false,
            data: seriesData2,
          }
        ]
      };
      let $instance = this.$echarts.init(this.$refs['twoChats']);
      $instance.setOption(option, true);
      $instance.on('click', params => {
        this.dialogFormVisibleLeft = true
        this.leftDialog(colorArr)
      });
    }
  }
}